import { useEffect } from 'react';
import type { DataState } from '@atlassian/jira-common-services/src/types';
// eslint-disable-next-line jira/restricted/@atlassian/react-resource-router
import { createResource, useResource } from '@atlassian/react-resource-router';
import type { CustomFieldsMapping } from '../../common/types';

const RESOURCE_TYPE_JSM_CUSTOM_FIELDS = 'RESOURCE_TYPE_JSM_CUSTOM_FIELDS';

const getDataLoader = () =>
	import(
		/* webpackChunkName: "async-resource-custom-fields", jiraSpaEntry: "async-resource-custom-fields" */ './get-data'
	);

type CustomFields = [
	DataState<CustomFieldsMapping>,
	{
		fetchCustomFields: () => void;
	},
];

export const customFieldsResource = createResource<CustomFieldsMapping>({
	type: RESOURCE_TYPE_JSM_CUSTOM_FIELDS,
	getKey: () => 'jsm_custom_fields',
	getDataLoader,
	maxAge: Infinity,
});

export const useGetCustomFields = (): CustomFields => {
	const {
		loading,
		data,
		error,
		refresh: fetchCustomFields,
	} = useResource<CustomFieldsMapping>(customFieldsResource);

	useEffect(() => {
		if (!loading && data == null && !error) {
			fetchCustomFields();
		}
	}, [loading, data, error, fetchCustomFields]);

	// @ts-expect-error - TS2322 - Type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to type 'Error | null'.
	return [{ loading, data, error }, { fetchCustomFields }];
};
